import { render, staticRenderFns } from "./QueueManagement.vue?vue&type=template&id=3db43ef2&"
import script from "./QueueManagement.vue?vue&type=script&lang=ts&"
export * from "./QueueManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports